import React, { FC } from 'react';

import { getAPIActivity } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Activity/utils';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

export const ActivityTab: FC = () => {
  const { resourceType } = useActiveResourceContext();

  return <>{getAPIActivity(resourceType)}</>;
};
